import React, { useEffect, useState } from 'react';
import { ValidButton } from '../buttons/validButton';

type ModalMaj = {
    message: string;
    handleActivateMaj: () => void;
    handleDesactivateMaj: () => void;
};

const MajModal: React.FC<ModalMaj> = ({ message, handleActivateMaj, handleDesactivateMaj }) => {
    const [escapeModal, setEscapeModal] = useState(false)
    const escapeMaj = () => {
        setEscapeModal(!escapeModal)
    }

    return (
        <>
            <div className="backgroundModal"></div>

            <div className="container_activeModeHl">
                <div className="modalHl">
                    <button className='escapeMaj' onClick={(() => { escapeMaj() })}>i</button>
                    {
                        escapeModal === false ?
                            <>
                                <p>{message}</p>
                                <div className="buttonModalHl">
                                    <ValidButton onClick={handleActivateMaj} >Télécharger</ValidButton>
                                </div>
                            </>

                            :
                            <>
                                <p>Êtes-vous sûr de ne pas vouloir effectuer la mise à jour ?
                                    Cette version améliore la stabilité et corrige plusieurs problèmes. Ne pas la faire pourrait entraîner des dysfonctionnements.</p>
                                <div className="buttonModalHl">
                                    <ValidButton onClick={handleDesactivateMaj} >Oui</ValidButton>
                                    <ValidButton onClick={escapeMaj} >Non</ValidButton>
                                </div>
                            </>
                    }

                </div>
            </div>
        </>
    );
};

export default MajModal;
